module.exports = __webpack_public_path__ + "img/germany-genitourinary-diseases-male.a9afd895.png";